<script lang="ts" setup>
const vimeoStorageID = 866078850
</script>

<template lang="pug">
section.media__epsilon
  h5 {{ $t('media.epsilon.title') }}
  p {{ $t('media.epsilon.subtitle') }}
  UIPlayer(:vimeo-id="vimeoStorageID")
</template>

<style lang="sass" scoped>
.media__epsilon
  @apply w-full h-full flex-center flex-col gap-4 xl:gap-8
  h5
    @apply font-bold text-xl lg:text-2xl xl:text-3xl text-center underline text-animated
  p
    @apply text-xs lg:text-sm xl:text-base text-white text-center lg:max-w-[80%]
</style>
